"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHardcodedGasLimits = exports.DEFAULT_GAS_ESTIMATES = exports.NATIVE_TOKEN = void 0;
const __1 = require("..");
exports.NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
exports.DEFAULT_GAS_ESTIMATES = {
    execute: "400000",
    executeL1: "20000",
    gasPriceFactor: "1000000000000000000",
};
const getHardcodedGasLimits = async (domainId, chainData) => {
    const chaindata = chainData ?? (await (0, __1.getChainData)());
    const chainInfo = chaindata?.get(domainId) ?? chainData?.get("0");
    if (!chainInfo)
        return exports.DEFAULT_GAS_ESTIMATES;
    const execute = chainInfo.gasEstimates?.execute ?? exports.DEFAULT_GAS_ESTIMATES.execute;
    const executeL1 = chainInfo.gasEstimates?.executeL1 ?? exports.DEFAULT_GAS_ESTIMATES.executeL1;
    const gasPriceFactor = chainInfo.gasEstimates?.gasPriceFactor ?? exports.DEFAULT_GAS_ESTIMATES.gasPriceFactor;
    const res = {
        execute,
        executeL1,
        gasPriceFactor,
    };
    return res;
};
exports.getHardcodedGasLimits = getHardcodedGasLimits;
//# sourceMappingURL=gas.js.map